/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse interface.
 */
export function instanceOfFxIdWebFeaturesFriendsSendFriendInviteNotificationResponse(value) {
    if (!('Sent' in value) || value['Sent'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSON(json) {
    return FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Sent': json['Sent'],
    };
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseToJSON(json) {
    return FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Sent': value['Sent'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFriendsSendFriendInviteNotificationResponse.js.map